import React from 'react';
import CircleSideBorder from '../../assets/images/icons/CircleSideBorder.svgr';

function transaction(props) {
    const { post, postType, replaceSelected } = props;

    let mainLogo;
    let secondaryLogo;
    let cardText;
    let categories;
    let categoryItems;
    if (post.acf.cardtext) {
        cardText = (
            <p
                className="transaction-card__text"
                dangerouslySetInnerHTML={{ __html: post.acf.cardtext }}
            />
        );
    }

    if (post.acf.main_logo) {
        mainLogo = (
            <span dangerouslySetInnerHTML={{ __html: post.acf.main_logo }} />
        );
    }

    if (post.acf.secondary_logo) {
        secondaryLogo = (
            <span
                dangerouslySetInnerHTML={{ __html: post.acf.secondary_logo }}
            />
        );
    }

    if (
        post.hasOwnProperty('_embedded') &&
        post._embedded.hasOwnProperty('wp:term')
    ) {
        categories = post._embedded['wp:term'][1];
    }

    if (categories) {
        categoryItems = categories.map((category, index) => {
            return (
                <li className="terms-list__item" key={index}>
                    <a
                        key={category.id}
                        onClick={() => {
                            replaceSelected(category.id, category.taxonomy);
                        }}
                        className="terms-list__link"
                    >
                        <span
                            className="terms__single"
                            dangerouslySetInnerHTML={{ __html: category.name }}
                        />
                    </a>
                </li>
            );
        });
    }

    return (
        <article
            id={`${postType}-${post.id}`}
            className="eight29-post eight29-post-card eight29-post-transaction transaction-card"
        >
            <div className="transaction-card__wrapper">
                <a href={post.link} className="transaction-card__link" />
                <div className="transaction-card__content">
                    <span className="transaction-card__side-border">
                        <CircleSideBorder />
                    </span>
                    <span className="transaction-card__side-border right">
                        <CircleSideBorder />
                    </span>
                    <figure className="transaction-card__top">
                        {mainLogo}
                        {cardText}
                        {secondaryLogo}
                    </figure>
                    <div className="transaction-card__terms">
                        <div className="transaction-card__term term-tag terms">
                            {categoryItems && (
                                <ul className="terms-list">{categoryItems}</ul>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </article>
    );
}

export default transaction;
